import { useEffect, useState } from 'react';

import Prism from 'prismjs';

import { withRetries } from '@cast/utils';

import './prism-theme.css';

export type HighlightedLanguage = keyof typeof components;

type Highlighter = {
  highlight: (text: string) => string;
  highlightAll: typeof import('prismjs').highlightAll;
};

type UseCodeHighlighterArgs = {
  language?: HighlightedLanguage;
  enabled?: boolean;
};

const components = {
  bash: () => import('prismjs/components/prism-bash'),
  json: () => import('prismjs/components/prism-json'),
  python: () => import('prismjs/components/prism-python'),
  sql: () => import('prismjs/components/prism-sql'),
  yaml: () => import('prismjs/components/prism-yaml'),
};

export const HIGHLIGHTED_LANGUAGES = new Set(
  Object.keys(components) as HighlightedLanguage[]
);

export const useCodeHighlighter = ({
  language,
  enabled = true,
}: UseCodeHighlighterArgs) => {
  const [highlighter, setHighlighter] = useState<Highlighter | null>(null);

  useEffect(() => {
    if (!language || !enabled) {
      return;
    }

    withRetries(components[language]).then(() => {
      const highlight = (text: string) => {
        return Prism.highlight(text, Prism.languages[language], language);
      };
      const highlightAll = Prism.highlightAll;
      setHighlighter({
        highlight,
        highlightAll,
      });
    });
  }, [language, enabled]);

  return highlighter;
};
